// ==============================|| OVERRIDES - LINK ||============================== //

import { color } from "framer-motion";

export default function Link() {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'hover',
        color:'#0061A3',
        fontWeight:'500'
      }
    }
  };
}
